import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.div`
    background: #FFFFFF;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    padding: 10px;
    position: relative;
    width: 350px;
`;

export const TitleContainer = styled.div`
    align-items: center;
    background: ${({ $background }) => $background ? $background : '#F6F6F6'};
    box-shadow: 1.461px 1.461px 0px 0px rgba(0, 0, 0, 0.25);
    border-radius: 2.5px;
    display: flex;
    height: max-content;
    justify-content: center;
    min-height: 65.739px;
    width: 100%;
`;

export const Title = styled.h1`
    color: ${({ $background }) => $background ? '#FFF' : '#333'};
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
`;

export const UnpinButton = styled.button`
    align-items: center;
    background: #FFFFFF;
    border: 1px solid #006560;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 34px;
    justify-content: center;
    outline: none;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 34px;

    &:hover{
        background-color: #F2F2F2;
        border-color: #33CC99;
    }
`;

export const UnpinImage = styled.img`
    display: flex;
    height: 20px;
    width: 20px;
`;

export const AccessButton = styled.button`
    align-items: center;
    background: #F6F6F6;
    border: none;
    border-radius: 10px;
    box-shadow: 0px 1.205px 1.205px 0px rgba(0, 0, 0, 0.15);
    color: #333;
    cursor: pointer;
    display: flex;
    font-size: 0px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 10px;
    text-align: center;
    width: 60px;
    @media (min-width: 1281px) {
        font-size: 15px;
        text-decoration: normal;
        width: 160px;
    }
`;

export const ButtonIcon = styled(SVG)`
    align-self: center;
    height: 20px;
    width: 20px;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 1281px) {
        height: 30px;
        width: 30px;
    }
`;

export const ButtonsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;
`;